<template>
    <div class="self-stretch inline-flex justify-between items-center overflow-hidden">
        <div class="flex justify-start items-center gap-3">
            <img v-if="logoUri" :src="logoUri" class="size-9 fill-white sm:hidden flex-shrink-0">
            <div class="inline-flex flex-col justify-center items-start">
                <div class="justify-start text-black text-sm font-normal font-dm-sans max-w-[80%] truncate">
                    {{ tenantName }}
                </div>
                <div class="justify-start text-neutral-500 text-sm font-normal font-dm-sans max-w-[80%] truncate">
                    {{ tenantDomain }}
                </div>
            </div>
        </div>
        <UButton
            variant="ghost"
            class="size-10"
            :to="localePath('index')"
            icon="ph:user-switch"
            :ui="{
                leadingIcon: 'text-neutral-700',
                base: 'flex-none w-10 h-10 bg-neutral-100 rounded-full inline-flex justify-center items-center overflow-hidden'
            }"/>
    </div>
</template>

<script setup lang="ts">
const localePath = useLocalePath()

defineProps<{
    tenantName: string,
    tenantDomain: string,
    logoUri?: string
}>()

</script>